// Writes a thank-you heading with the buyer's first name for {name}, or closes the sentence up when there is none.
export const confirmationHeading = (heading: string, fullName: string): string => {
  const first = fullName.trim().split(/\s+/)[0] ?? '';
  if (first) return heading.split('{name}').join(first);
  return heading.replace(/,?\s*\{name\}\s*,?/g, ' ').replace(/\s+([!?.,])/g, '$1').replace(/\s{2,}/g, ' ').trim();
};
